import React, {Component, useState} from "react";
import Leftmenu from "../element/leftmenu";
import Header from "../element/header";
import PageBreadcrumb from "../element/pagebreadcrumb";
import {DownloadOutlined} from "@ant-design/icons";
import {
    Layout,
    Col,
    Row,
    PageHeader,
    Button,
    Descriptions,
    Typography,
    InputNumber,
    Slider,
    Input,
    Space,
    DatePicker,
    Select,
    Table,
    Tag,
    Radio,
    Tabs,
    Spin
} from 'antd';
import 'moment/locale/zh-cn';
import moment from "moment";

const {Title, Text} = Typography;
const {Content} = Layout;
const {RangePicker} = DatePicker;
const { TabPane } = Tabs;

const columns = [
    {
        title: '序号',
        dataIndex: 'key',
        key: 'key'
    },
    {
        title: '类型',
        dataIndex: 'type',
        key: 'type',
        render: (type) => <p>{type ? type : '/'}</p>,
    },
    {
        title: '销量（吨）',
        dataIndex: 'sum',
        key: 'sum',
        sorter: (a, b) => a.sum - b.sum,
        render: (sum) => <p>{sum ? sum : '0.00'}</p>,
    },
    {
        title: '订单量',
        dataIndex: 'num',
        key: 'num',
        sorter: (a, b) => a.num - b.num,
        render: (num) => <p>{num ? num : 0}</p>,
    }
];
const columnsarea = [
    {
        title: '序号',
        dataIndex: 'key',
        key: 'key'
    },
    {
        title: '区域',
        dataIndex: 'area',
        key: 'area',
        render: (area) => <p>{area ? area : '/'}</p>,
    },
    {
        title: '销量（吨）',
        dataIndex: 'sum',
        key: 'sum',
        sorter: (a, b) => a.sum - b.sum,
        render: (sum) => <p>{sum ? sum : '0.00'}</p>,
    }
];
const columnsman = [
    {
        title: '序号',
        dataIndex: 'key',
        key: 'key'
    },
    {
        title: '销售',
        dataIndex: 'man',
        key: 'man',
        render: (man) => <p>{man ? man : '/'}</p>,
    },
    {
        title: '销量（吨）',
        dataIndex: 'sum',
        key: 'sum',
        sorter: (a, b) => a.sum - b.sum,
        render: (sum) => <p>{sum ? sum : '0.00'}</p>,
    }
];
const columnscus = [
    {
        title: '序号',
        dataIndex: 'key',
        key: 'key'
    },
    {
        title: '客户',
        dataIndex: 'type',
        key: 'type',
        render: (type) => <p>{type ? type : '/'}</p>,
    },
    {
        title: '区域',
        dataIndex: 'area',
        key: 'area',
        render: (area) => <p>{area ? area : '/'}</p>,
    },
    {
        title: '销售',
        dataIndex: 'man',
        key: 'man',
        render: (man) => <p>{man ? man : '/'}</p>,
    },
    {
        title: '销量（吨）',
        dataIndex: 'sum',
        key: 'sum',
        sorter: (a, b) => a.sum - b.sum,
        render: (sum) => <p>{sum ? sum : '0.00'}</p>,
    },
    {
        title: '订单量',
        dataIndex: 'num',
        key: 'num',
        sorter: (a, b) => a.num - b.num,
        render: (num) => <p>{num ? num : 0}</p>,
    }
];

const Load = (that,date) => {/*
    const end = date.format('YYYY-MM');
    const start = date.subtract(1, "months").format('YYYY-MM');
    that.setState({
        start: start + "-26",
        end: end + "-26"
    });*/
    const start = date.format('YYYY-MM') + "-01";
    const end = date.add(1, "months").format('YYYY-MM') + "-01";
    that.setState({
        start: start,
        end: end
    });

    fetch("https://pd.pokemonbye.com:8081/api/getweightdatatypebydate?start="+start+"&end="+end)
        .then(res => res.json())
        .then(
            (result) => {
                let array = result.data;
                var listsum = 0;
                var listnum = 0;
                if(array!=null&&array.length>0){
                    for (let i = 0; i < array.length; i++) {
                        array[i].key = i + 1;
                        listsum += parseFloat(array[i].sum)
                        listnum += parseFloat(array[i].num)
                    }
                }
                that.setState({
                    isLoaded: true,
                    list: array,
                    listsum: listsum.toFixed(2),
                    listnum: listnum
                });
            },
            // 注意：需要在此处处理错误
            // 而不是使用 catch() 去捕获错误
            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
            (error) => {
                that.setState({
                    isLoaded: true,
                    error
                });
            }
        )

    fetch("https://pd.pokemonbye.com:8081/api/getweightdataclientbydate?start="+start+"&end="+end)
        .then(res => res.json())
        .then(
            (result) => {
                let array = result.data;
                if(array!=null&&array.length>0){
                    for (let i = 0; i < array.length; i++) {
                        array[i].key = i + 1;
                    }
                }
                that.setState({
                    isLoaded: true,
                    listman: array
                });
            },
            // 注意：需要在此处处理错误
            // 而不是使用 catch() 去捕获错误
            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
            (error) => {
                that.setState({
                    isLoaded: true,
                    error
                });
            }
        )

    fetch("https://pd.pokemonbye.com:8084/api/getsellclientlist")
        .then(res => res.json())
        .then(
            (result) => {
                let list = result.data;
                if(list!=null&&list.length>0){


                    fetch("https://pd.pokemonbye.com:8081/api/getweightdataclientbydate?start="+start+"&end="+end)
                        .then(res => res.json())
                        .then(
                            (result) => {
                                let array = result.data;
                                var listsum = 0;
                                var listnum = 0;
                                var listarea = [];
                                var listman = [];
                                if(array!=null&&array.length>0){
                                    for (let i = 0; i < array.length; i++) {
                                        array[i].key = i + 1;
                                        listsum += parseFloat(array[i].sum)
                                        listnum += parseFloat(array[i].num)

                                        for (let j = 0; j < list.length; j++) {

                                            if(array[i].type == list[j].name){
                                                array[i].area = list[j].area
                                            }
                                        }
                                    }
                                    const result = array.reduce((acc, cur) =>{
                                        if(acc[cur.area]){
                                            acc[cur.area] += parseFloat(cur.sum)
                                        } else {
                                            acc[cur.area] = parseFloat(cur.sum)
                                        }
                                        return acc
                                    },{})
                                    for (let i = 0; i < Object.entries(result).length; i++) {
                                        var name = Object.entries(result)[i][0]
                                        if(Object.entries(result)[i][0]=='undefined'){
                                            name = '/'
                                        }
                                        var l =
                                            {
                                                'key': i+1,
                                                'area':name,
                                                'sum': Object.entries(result)[i][1].toFixed(2)
                                            }
                                        listarea.push(l)
                                    }
                                    fetch("https://pd.pokemonbye.com:8084/api/getsellcontractmanbydate?date=" + end)
                                        .then(res => res.json())
                                        .then(
                                            (result) => {
                                                let man = result.data;
                                                if(man!=null&&man.length>0){
                                                    for (let i = 0; i < array.length; i++) {
                                                        array[i].key = i + 1;

                                                        for (let j = 0; j < man.length; j++) {

                                                            if(array[i].type == man[j].client){
                                                                array[i].man = man[j].name
                                                            }
                                                        }
                                                    }
                                                    const result = array.reduce((acc, cur) =>{
                                                        if(acc[cur.man]){
                                                            acc[cur.man] += parseFloat(cur.sum)
                                                        } else {
                                                            acc[cur.man] = parseFloat(cur.sum)
                                                        }
                                                        return acc
                                                    },{})
                                                    for (let i = 0; i < Object.entries(result).length; i++) {
                                                        var name = Object.entries(result)[i][0]
                                                        if(Object.entries(result)[i][0]=='undefined'){
                                                            name = '/'
                                                        }
                                                        var l =
                                                            {
                                                                'key': i+1,
                                                                'man':name,
                                                                'sum': Object.entries(result)[i][1].toFixed(2)
                                                            }
                                                        listman.push(l)
                                                    }
                                                    that.setState({
                                                        isLoaded: false,
                                                        listman: listman,
                                                        listcus: array,
                                                        listsumcus: listsum.toFixed(2),
                                                        listnumcus: listnum,
                                                        listarea: listarea,
                                                    });

                                                }
                                            },
                                            // 注意：需要在此处处理错误
                                            // 而不是使用 catch() 去捕获错误
                                            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                                            (error) => {
                                                that.setState({
                                                    isLoaded: true,
                                                    error
                                                });
                                            }
                                        )

                                }else{
                                    that.setState({
                                        isLoaded: false,
                                        listman: listman,
                                        listcus: array,
                                        listsumcus: listsum.toFixed(2),
                                        listnumcus: listnum,
                                        listarea: listarea,
                                    });
                                }
                                that.setState({
                                    isLoaded: false
                                });
                            },
                            // 注意：需要在此处处理错误
                            // 而不是使用 catch() 去捕获错误
                            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                            (error) => {
                                that.setState({
                                    isLoaded: true,
                                    error
                                });
                            }
                        )

                }
            },
            // 注意：需要在此处处理错误
            // 而不是使用 catch() 去捕获错误
            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
            (error) => {
                that.setState({
                    isLoaded: true,
                    error
                });
            }
        )

    date.subtract(1, "months").format('YYYY-MM');
}

class PageDataFormClient extends Component {


    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        const pid = params.get("area");
        var day = moment().format('DD')/*
        var month = moment().add(1, "months")
        if(day < 26){
            month = moment()
        }*/
        var month = moment()
        this.state = {
            title: "销售月报",
            county: [],
            area: pid,
            list: [],
            listman: [],
            listcus: [],
            month: month,
            tab: "1",
        };
    }

    componentDidMount() {
        Load(this,this.state.month)
    }

    render() {
        const onChange = (date, dateString) => {
            console.log(date)
            Load(this,date)
        };
        const onTabChange = (num) => {
            console.log(num)
            this.setState({
                tab: num
            });
        };
        const onClick = () => {
            switch(this.state.tab){
                case "1":
                    fetch("https://pd.pokemonbye.com:8081/api/getweightdatatypeexcel?start="+this.state.start+"&end="+this.state.end)
                        .then(res => res.json())
                        .then(
                            (result) => {
                                let array = result.data;
                                if(array!=null&&array.length>0){
                                    window.open(array[0]);
                                }
                            },
                            // 注意：需要在此处处理错误
                            // 而不是使用 catch() 去捕获错误
                            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                            (error) => {

                            }
                        )
                    break;
                case "2":
                    fetch("https://pd.pokemonbye.com:8081/api/getweightdataclientexcel?start="+this.state.start+"&end="+this.state.end)
                        .then(res => res.json())
                        .then(
                            (result) => {
                                let array = result.data;
                                if(array!=null&&array.length>0){
                                    window.open(array[0]);
                                }
                            },
                            // 注意：需要在此处处理错误
                            // 而不是使用 catch() 去捕获错误
                            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                            (error) => {

                            }
                        )
                    break;
                case "3":
                    fetch("https://pd.pokemonbye.com:8081/api/getweightdataclientexcel?start="+this.state.start+"&end="+this.state.end)
                        .then(res => res.json())
                        .then(
                            (result) => {
                                let array = result.data;
                                if(array!=null&&array.length>0){
                                    window.open(array[0]);
                                }
                            },
                            // 注意：需要在此处处理错误
                            // 而不是使用 catch() 去捕获错误
                            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                            (error) => {

                            }
                        )
                    break;
            }
        };
        return (
            <div>
                <Leftmenu/>
                <div className="mainpanel">
                    <Header/>
                    <PageBreadcrumb title={this.state.title}/>
                    <Content className="site-layout-background">
                        <div className="site-page-header-ghost-wrapper">
                            <PageHeader
                                ghost={false}
                                onBack={() => window.history.back()}
                                title={this.state.title}
                                subTitle="根据条件进行查询月报"
                            >
                                <Space>
                                    <DatePicker defaultValue={this.state.month} onChange={onChange} picker="month"/>
                                    <Button type="primary" onClick={onClick}>下载</Button>
                                </Space>
                                <Spin spinning={this.state.isLoaded}>
                                <Tabs defaultActiveKey="1" onChange={onTabChange}>
                                    <Tabs.TabPane tab="类型" key="1">
                                        <Table bordered columns={columns} dataSource={this.state.list}
                                               summary={() => (
                                                   <Table.Summary fixed>
                                                       <Table.Summary.Row>
                                                           <Table.Summary.Cell index={0} colSpan={2}>合计</Table.Summary.Cell>
                                                           <Table.Summary.Cell index={1}>{this.state.listsum}</Table.Summary.Cell>
                                                           <Table.Summary.Cell index={2}>{this.state.listnum}</Table.Summary.Cell>
                                                       </Table.Summary.Row>
                                                   </Table.Summary>
                                               )}/>
                                    </Tabs.TabPane>
                                    <Tabs.TabPane tab="客户" key="2">
                                        <Table bordered columns={columnscus} dataSource={this.state.listcus}
                                               summary={() => (
                                                   <Table.Summary fixed>
                                                       <Table.Summary.Row>
                                                           <Table.Summary.Cell index={0} colSpan={4}>合计</Table.Summary.Cell>
                                                           <Table.Summary.Cell index={1}>{this.state.listsumcus}</Table.Summary.Cell>
                                                           <Table.Summary.Cell index={2}>{this.state.listnumcus}</Table.Summary.Cell>
                                                       </Table.Summary.Row>
                                                   </Table.Summary>
                                               )}/>
                                    </Tabs.TabPane>
                                    <Tabs.TabPane tab="区域" key="3">
                                        <Table bordered columns={columnsarea} dataSource={this.state.listarea}
                                               summary={() => (
                                                   <Table.Summary fixed>
                                                       <Table.Summary.Row>
                                                           <Table.Summary.Cell index={0} colSpan={2}>合计</Table.Summary.Cell>
                                                           <Table.Summary.Cell index={1}>{this.state.listsumcus}</Table.Summary.Cell>
                                                       </Table.Summary.Row>
                                                   </Table.Summary>
                                               )}/>
                                    </Tabs.TabPane>
                                    <Tabs.TabPane tab="销售" key="4">
                                        <Table bordered columns={columnsman} dataSource={this.state.listman}
                                               summary={() => (
                                                   <Table.Summary fixed>
                                                       <Table.Summary.Row>
                                                           <Table.Summary.Cell index={0} colSpan={2}>合计</Table.Summary.Cell>
                                                           <Table.Summary.Cell index={1}>{this.state.listsumcus}</Table.Summary.Cell>
                                                       </Table.Summary.Row>
                                                   </Table.Summary>
                                               )}/>
                                    </Tabs.TabPane>
                                </Tabs>
                                </Spin>
                            </PageHeader>
                        </div>
                    </Content>
                </div>
            </div>
        );
    }
}

export default PageDataFormClient;


